import axios from 'axios'
import { SpecificFileRequest } from '../models/types'

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/document-file`

async function fetchSignedFileUrl({ folder, fileUuid }: SpecificFileRequest): Promise<string> {
  return (await axios.get<string>(`${baseUrl}/${folder}/${fileUuid}`)).data
}

export default fetchSignedFileUrl
